import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/Actions/actions";
import "../Column.scss";
import Popup from "../../../Modal/Popup";
import * as UTILS from "../../../../utils/Utils";
import GridColumnLayout from "../../../../containers/gridColumnLayout";
import swal from "sweetalert";

class LayoutChangeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    componentDidMount = () => {

    };

    columnsDifferenceCheckNAlert = async (e, ID, deskWidth) => {
        if (this.props.deskWidth.length > deskWidth.length) {
            const willDelete = await swal({
                title: "Are you sure?",
                text: `You will lose ${this.props.deskWidth.length - deskWidth.length} column(s). Want to proceed?`,
                icon: "warning",
                className: "sweet-alert-confirmation",
                dangerMode: true,
                buttons: ["No", "Yes"]
            });

            if (!willDelete) {
                return false;
            }
        }
        this.props.changeColmLayout(e, this.props.ID, deskWidth)
    }

    render() {

        return (
          <Fragment>
            <Popup
              width="700"
              header="Column Layouts"
              parentID="columnlayout"
              closePopup={() => this.props.setIdForLayoutChange(null)}
              close={() => this.props.setIdForLayoutChange(null)}
            >
              <div className="mainSection modalScrollContainer">
                <ul className="layout-section">
                  {UTILS.columnLayouts.map((layout, index) => {
                    return (
                      <li
                        key={index}
                        className={`${
                          JSON.stringify(this.props.deskWidth) ===
                          JSON.stringify(layout.deskWidth)
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) =>
                          this.columnsDifferenceCheckNAlert(
                            e,
                            this.props.ID,
                            layout.deskWidth
                          )
                        }
                      >
                        <GridColumnLayout colmLayout={layout.colmLayout} />
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="clearfix"></div>
            </Popup>
          </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        layout: state.present.layout,
        glblClrs: state.present.colorsGlobal,
        preset: state.present.preset,
        containerBg: state.present.containerBgColor,
        containerWidth: state.present.containerWidth,
        pixel: state.present.pixel,
        percentage: state.present.percentage,
        imagesGlobal: state.present.imagesGlobal,
        bgImage: state.present.bgImage,
        bgImageId: state.present.bgImageId,
        bgImageIndex: state.present.bgImageIndex,
        layoutTitle: state.present.layoutTitle,
        selectedFont: state.present.selectedFont,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        pushGlobalColorArray: (colorGlobal) =>
            dispatch(actionTypes.global_colors(colorGlobal)),
        pushGlobalColorPreset: (presetColor) =>
            dispatch(actionTypes.preset(presetColor)),
        pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
        pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
        pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
        pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
        pushPercentage: (percentageVal) =>
            dispatch(actionTypes.percentage(percentageVal)),
        pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
        pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
        pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
        layoutArray: (titleValue, layoutVal) =>
            dispatch(
                actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutChangeModal);
